import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const BaseAddressSelect = ({ onSelect, testId }) => {
  const [bases, setBases] = useState([]);
  useEffect(() => {
    api.get("/cities")
      .then((r) => setBases((r.data || []).filter((c) => (c.address || "").trim())))
      .catch(() => {});
  }, []);
  if (!bases.length) return null;
  return (
    <select
      className="h-6 rounded-md border border-input bg-white px-1.5 text-[11px] text-gray-600 cursor-pointer"
      value=""
      onChange={(e) => {
        const c = bases.find((b) => b.code === e.target.value);
        if (c) onSelect(c);
        e.target.value = "";
      }}
      data-testid={testId}
    >
      <option value="">Auto-fill from base…</option>
      {bases.map((c) => (
        <option key={c.code} value={c.code}>{c.code} — {c.name}</option>
      ))}
    </select>
  );
};
